import React, { useMemo } from 'react';
import { sentiment_frontier } from '../constants';
import { getShowCount } from '@/pages/opinion/utils';
import {
  getContentDetail,
  getFeedsKeywordText,
} from '@/pages/opinion/utils/languageValue';
import { LanguageType } from '@/pages/opinion/types/common';
import './index.scss';
import RingRatioBubble from '../RingRatioBubble';
import { DBO_V } from '@op/utils/format';
import PercentageItem from '../PercentageItem';
import useLanguage from '@op/hooks/useLanguage';
import moment from 'moment';
import { formatDateFunc } from '@op/utils/time';
import { goStatsDetailAction } from '@op/pages/stats/Detail';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';

/**
 * 关键字小组件
 * @param keyword            显示的关键字
 * @param sentiment_rating   分数，决定了显示的样式， 2.5分以下就是红，大于3.5为绿色，其他的为灰色
 * @param count              数量
 * @returns
 */
export default function KeywordItem({
  keyword,
  itemClick,
  languageMap,
  language = 'origin',
  sentiment_rating,
  count,
  hideCount = false,
  active = true,
}: {
  sentiment_rating: number;
  count: number;
  keyword: { [key: string]: any };
  itemClick: () => void;
  languageMap: {
    origin: string;
    en: string;
    zh: string;
  };
  language: LanguageType;
  hideCount?: boolean;
  active?: boolean;
}) {
  let status = 'bad';
  let { bad, medium } = sentiment_frontier;
  if (sentiment_rating > bad) {
    status = 'medium';
  }
  if (sentiment_rating > medium) {
    status = 'good';
  }

  return (
    <div
      className={`dbo-keyword-item-wrapper ${
        active ? '' : 'no-keyword-active'
      } ${hideCount ? 'tag-modal' : status} `}
      onClick={(e) => {
        e.stopPropagation();
        itemClick();
      }}
    >
      <p>{getContentDetail(languageMap, language, keyword)}</p>
      {!hideCount && <p className="dbo-keyword-count">{getShowCount(count)}</p>}
    </div>
  );
}

type RisingKeywordsItemProps = {
  item: {
    key: string;
    count: number;
    sentiment_rating: number;
    oldValue: number;
    ratio: number;
    date_type: string;
    oldTime: string[];
    newTime: string[];
    type: '--negative' | '--positive';
    old_count: number;
  };
  text: string;
  language: LanguageType;
  onClick: (event: any) => void;
  formatDate: any;
};

export function RisingKeywordItem({
  item,
  language,
  onClick,
  text,
  formatDate,
}: RisingKeywordsItemProps) {
  const { formatMessage } = useLanguage();

  return (
    <div className={`rising-keywords-item ${item.type}`} onClick={onClick}>
      <RingRatioBubble
        formateValue={DBO_V.reviews}
        formateDate={formatDate}
        oldTime={item.oldTime}
        newTime={item.newTime}
        oldValue={item.old_count}
        newValue={item.count}
        otherInfo={
          <PercentageItem
            percentage={item?.ratio}
            className="dbo-rising-keywords-percent"
          />
        }
        title={`${formatMessage({ id: 'Keyword' })} ${formatMessage({
          id: text,
        })}`}
      >
        <span className="rising-keywords-item-text">
          {getFeedsKeywordText(item, language || 'origin')}
        </span>
        <span className="rising-keywords-item-num">{item.count}</span>
      </RingRatioBubble>
    </div>
  );
}
 